import BaseModel from "@/api/models/BaseModel";

/**
 * SupportTicketDictionary
 */
export default class SupportTicketDictionary extends BaseModel {
    
    constructor() {
        super();

        this.OPEN = 1,
        this.IN_PROGRESS = 2,
        this.CLOSED = 3
    }

    /**
     * Gets all SupportTicket statuses
     * @returns {Array<{label: String, value: String}>}
     */
    getAll(ignore = []) {
        return [
            { label: 'all', value: '' },
            { label: 'open', value: this.OPEN },
            { label: 'in progress', value: this.IN_PROGRESS },
            { label: 'closed', value: this.CLOSED }
        ].filter(item => !ignore.includes(item.value));
    }

    /**
     * Gets label for a given SupportTicket status value
     * @param {String} value
     * @returns {String}
     */
    getLabel(value) {
        const all = this.getAll();

        let label = '';
        for (let item of all) {
            if (parseInt(item.value) === parseInt(value)) {
                label = item.label;
                break;
            }
        }

        return label || '';
    }
}